export default interface SurveyorCompletionStatus {
    InspectionId: string;
    ChecklistComplete: boolean;
    PhotosComplete: boolean;
    DocumentsComplete: boolean;
    InspectionComplete: boolean;
    CarbonSectionComplete: boolean;
    CarbonSectionComment: string;
    ChecklistComment: string;
    PhotosComment: string;
    DocumentsComment: string;
    InspectionComment: string;
    EmbarkDate?: string;
    DisembarkDate?: string;
}

export const defaultSurveyorCompletionStatus = (
    inspectionId: string
): SurveyorCompletionStatus => {
    const initialSurveyor = {
        InspectionId: inspectionId,
        ChecklistComplete: false,
        PhotosComplete: false,
        DocumentsComplete: false,
        CarbonSectionComplete: false,
        InspectionComplete: false,
        CarbonSectionComment: "",
        ChecklistComment: "",
        PhotosComment: "",
        DocumentsComment: "",
        InspectionComment: "",
        EmbarkDate: undefined,
        DisembarkDate: undefined
    };

    return initialSurveyor;
};

export const createSurveyorCompletionStatus = (): SurveyorCompletionStatus => {
    const initialSurveyor = {
        InspectionId: "",
        ChecklistComplete: false,
        PhotosComplete: false,
        DocumentsComplete: false,
        CarbonSectionComplete: false,
        InspectionComplete: false,
        CarbonSectionComment: "",
        ChecklistComment: "",
        PhotosComment: "",
        DocumentsComment: "",
        InspectionComment: "",
        EmbarkDate: undefined,
        DisembarkDate: undefined
    };

    return initialSurveyor;
};
